import { Box, Link as MuiLink, Typography } from '@mui/material';
import Markdown from 'markdown-to-jsx';
import React from 'react';
const MarkdownRenderer = ({
  content
}: {
  content: string;
}) => {
  const getQueryParams = (url: string) => {
    const params: Record<string, string> = {};
    const queryString = url.split('?')[1];
    if (queryString) {
      const pairs = queryString.split('&');
      pairs.forEach(pair => {
        const [key, value] = pair.split('=');
        if (key && value) {
          params[key] = decodeURIComponent(value);
        }
      });
    }
    return params;
  };
  if (!content) {
    return null;
  }
  return <Markdown options={{
    overrides: {
      a: {
        component: MuiLink,
        props: {
          target: '_blank',
          rel: 'noopener noreferrer',
          sx: {
            fontWeight: 'bold'
          }
        }
      },
      h1: {
        component: Typography,
        props: {
          variant: 'h4',
          component: 'h1',
          gutterBottom: true
        }
      },
      h2: {
        component: Typography,
        props: {
          variant: 'h5',
          component: 'h2',
          gutterBottom: true
        }
      },
      h3: {
        component: Typography,
        props: {
          variant: 'h6',
          component: 'h3',
          gutterBottom: true
        }
      },
      p: {
        component: Typography,
        props: {
          variant: 'body1',
          paragraph: true
        }
      },
      span: {
        component: Typography,
        props: {
          variant: 'body1',
          paragraph: true,
          display: 'inline'
        }
      },
      blockquote: {
        component: Box,
        props: {
          component: 'blockquote',
          sx: {
            borderLeft: '4px solid #ccc',
            margin: '16px 0',
            paddingLeft: '16px',
            color: 'rgba(0, 0, 0, 0.7)',
            fontStyle: 'italic'
          }
        }
      },
      ul: {
        component: Box,
        props: {
          component: 'ul',
          sx: {
            paddingLeft: '20px',
            margin: '16px 0'
          }
        }
      },
      ol: {
        component: Box,
        props: {
          component: 'ol',
          sx: {
            paddingLeft: '20px',
            margin: '16px 0'
          }
        }
      },
      li: {
        component: Box,
        props: {
          component: 'li',
          sx: {
            marginBottom: '8px',
            listStyle: 'initial'
          }
        }
      },
      code: {
        component: ({
          children
        }: {
          children?: React.ReactNode;
        }) => <Box component="code" sx={{
          fontFamily: 'monospace',
          backgroundColor: '#f5f5f5',
          color: '#212121',
          padding: '2px 4px',
          borderRadius: '4px',
          fontSize: '0.875em'
        }}>
                {children}
              </Box>
      },
      img: {
        component: ({
          src,
          alt
        }: {
          src?: string;
          alt?: string;
        }) => {
          if (!src) {
            return null;
          }
          const params = getQueryParams(src);
          const styles = {
            maxWidth: params.maxWidth ? `${params.maxWidth}px` : '100%',
            maxHeight: params.maxHeight ? `${params.maxHeight}px` : 'inherit',
            borderRadius: '8px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            margin: '0px auto',
            display: 'block',
            width: '100%'
          };
          const cleanSrc = src.split('?')[0];
          return <Box component="img" src={cleanSrc} alt={alt} sx={styles} />;
        }
      }
    }
  }} data-sentry-element="Markdown" data-sentry-component="MarkdownRenderer" data-sentry-source-file="MarkdownRenderer.tsx">
      {content}
    </Markdown>;
};
export default MarkdownRenderer;